<span
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [iuValidationDisplay]="data?.hasValidation"
  [iuValidationDisplay.datacontainer]="this"
  [iuValidationDisplay.iconIdx]="1"
  [iuValidationDisplay.inputSelector]="'input.p-inputtext.input-field'"
  [iuValidationDisplay.valid]="isValid()"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss"
  (contextmenu)="onContextMenu($event)"
  (press)="onContextMenu($any($event))">
  @if (isLabelDisplay && !(displayImage && fieldValue !== undefined && fieldValue !== null)) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      {{ label }}
    </label>
  }
  @if (!(displayImage && fieldValue !== undefined && fieldValue !== null)) {
    <input
      #input
      autocomplete="off"
      data-cy="input-text"
      type="text"
      value=""
      [attr.data-cy-columnName]="data ? data.columnName : columnName"
      [id]="uuid"
      [ngClass]="[mandatoryCss || '', 'ui-corner-all', 'input-field p-inputtext']"
      [readonly]="isReadOnly ? 'disabled' : null"
      [tabindex]="isReadOnly ? '-1' : null"
      [(ngModel)]="fieldValue"
      (change)="dataChange(input.value)" />
  }
  @if (!(displayImage && fieldValue !== undefined && fieldValue !== null && fieldValue !== '')) {
    <i #ddBtn aria-hidden="true" class="picto icon-img" type="button" (click)="switchField()"> </i>
  }

  @if (displayImage && fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
    <img
      alt="image"
      data-cy="input-image"
      [attr.data-cy-columnName]="data ? data.columnName : columnName"
      [attr.height]="height"
      [attr.width]="width"
      [ngClass]="[!isReadOnly ? 'iu-image-hover' : '', 'iu-image']"
      [src]="fieldValue | docServerUrl | async"
      (click)="switchField()" />
  }
  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="data"
        [dataStored]="dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>
